import { render, staticRenderFns } from "./editFeishu.vue?vue&type=template&id=11dbbfea&scoped=true"
import script from "./editFeishu.vue?vue&type=script&lang=js"
export * from "./editFeishu.vue?vue&type=script&lang=js"
import style0 from "./editFeishu.vue?vue&type=style&index=0&id=11dbbfea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dbbfea",
  null
  
)

export default component.exports